export default __webpack_public_path__ + "static/media/img-1.41c751ed.jpg";